import { AppBundle } from 'api/optimalprint-sdk.d';
import productMatchAttributes from './productMatchAttributes';

type AbstractProductAttribute =
  AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.ProductItem.IAttribute;
type ProductItem = AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem;

const filterProducts = (products: ProductItem[], attributesToFilter: AbstractProductAttribute[]) => {
  if (attributesToFilter.length === 0) {
    return products;
  }
  return products.filter((productItem) => productMatchAttributes(productItem, attributesToFilter));
};

export default filterProducts;
